import * as React from "react";
import * as PropTypes from "prop-types";
import Rate from "src/packages/rate/Rate";
import Code from "src/components/Code";
import CodeBox from "src/components/CodeBox";
import Space from "src/components/Space";
import { renderString } from "src/utils/renderCode";

const componentName = "RateExample";

class RateExample extends React.Component {
  public static displayName = componentName;

  public static propTypes = {};

  public static defaultProps = {};

  public state = {
    tips: "三星"
  };

  private tipsArray: string[] = [
    "请评分",
    "一星",
    "两星",
    "三星",
    "四星",
    "五星"
  ];

  public handleChange = (value: number) => {
    this.setState({
      tips: this.tipsArray[value]
    });
  };

  public render() {
    const cn = componentName;

    return (
      <div className="rate-example">
        <section>
          <h1>Rate 评分</h1>
          <p className="text">星级评分组件。</p>
        </section>
        <section>
          <h2>何时使用</h2>
          <p className="text">需要用户进行快速评级或向用户展示评价时。</p>
        </section>
        <section>
          <h2>代码示例</h2>
        </section>
        <div className="example">
          <div className="container">
            <Rate defaultValue={1} />
          </div>
          <CodeBox title="基本用法" description="最基本的用法。">
            {renderString(`import { Rate } from 'xue-react'`)}
            {renderString(`import 'xue-react/lib/xue-react.css'`)}
            <br />
            <Code code={`&lt;Rate defaultValue={1} /&gt;`} />
          </CodeBox>
        </div>
        <div className="example">
          <div className="container">
            <Rate
              defaultValue={3}
              onChange={value => this.handleChange(value)}
              tips={this.state.tips}
            />
          </div>
          <CodeBox title="文案描述" description="给评分结果配以文字描述。">
            {renderString(`import { Rate } from 'xue-react'`)}
            {renderString(`import 'xue-react/lib/xue-react.css'`)}
            <br />
            <Code
              code={`&lt;Rate defaultValue={3} onChange={(value) => this.handleChange(value)} tips={this.state.tips} /&gt;`}
            />
          </CodeBox>
        </div>
        <div className="example">
          <div className="container">
            <Rate defaultValue={2.5} allowHalf={true} />
          </div>
          <CodeBox title="半星" description="支持选中半星。">
            {renderString(`import { Rate } from 'xue-react'`)}
            {renderString(`import 'xue-react/lib/xue-react.css'`)}
            <br />
            <Code code={`&lt;Rate defaultValue={2.5} allowHalf={true} /&gt;`} />
          </CodeBox>
        </div>
        <div className="example">
          <div className="container">
            <Rate defaultValue={2} allowClear={true} />
          </div>
          <CodeBox title="清除" description="允许再次点击清除。">
            {renderString(`import { Rate } from 'xue-react'`)}
            {renderString(`import 'xue-react/lib/xue-react.css'`)}
            <br />
            <Code code={`&lt;Rate defaultValue={2} allowClear={true} /&gt;`} />
          </CodeBox>
        </div>
        <div className="example">
          <div className="container">
            <Rate defaultValue={4} disabled={true} />
          </div>
          <CodeBox
            title="禁用"
            description="禁用状态下评分只读，无法进行鼠标交互，典型的使用场景是用户评分完成后设置禁用防止重复评分或修改。"
          >
            {renderString(`import { Rate } from 'xue-react'`)}
            {renderString(`import 'xue-react/lib/xue-react.css'`)}
            <br />
            <Code code={`&lt;Rate defaultValue={4} disabled={true} /&gt;`} />
          </CodeBox>
        </div>
        <section>
          <h2>API</h2>
        </section>
        <table className="api-table">
          <thead>
            <tr>
              <th>参数</th>
              <th className="des">说明</th>
              <th className="type">类型</th>
              <th>默认值</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>value</td>
              <td className="des">当前值</td>
              <td className="type">number</td>
              <td>——</td>
            </tr>
            <tr>
              <td>defaultValue</td>
              <td className="des">默认值</td>
              <td className="type">number</td>
              <td>——</td>
            </tr>
            <tr>
              <td>onChange</td>
              <td className="des">数值变化时的回调</td>
              <td className="type">(value: number) => any</td>
              <td>——</td>
            </tr>
            <tr>
              <td>onHoverChange</td>
              <td className="des">鼠标经过时数值变化的回调</td>
              <td className="type">(value: number) => any</td>
              <td>——</td>
            </tr>
            <tr>
              <td>tips</td>
              <td className="des">提示信息</td>
              <td className="type">string | React.ReactNode</td>
              <td>——</td>
            </tr>
            <tr>
              <td>allowClear</td>
              <td className="des">是否允许再次点击后清除</td>
              <td className="type">boolean</td>
              <td>false</td>
            </tr>
            <tr>
              <td>allowHalf</td>
              <td className="des">是否允许半选</td>
              <td className="type">boolean</td>
              <td>false</td>
            </tr>
            <tr>
              <td>disabled</td>
              <td className="des">只读状态，无法交互</td>
              <td className="type">boolean</td>
              <td>false</td>
            </tr>
            <tr>
              <td>className</td>
              <td className="des">自定义 Rate 容器类名</td>
              <td className="type">string</td>
              <td>——</td>
            </tr>
            <tr>
              <td>style</td>
              <td className="des">自定义 Rate 容器样式</td>
              <td className="type">React.CSSProperties</td>
              <td>——</td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }
}

export default RateExample;



// WEBPACK FOOTER //
// ./src/examples/Rate.example.tsx